import React from 'react';
export function Footer() {
  return <footer className="py-10 px-4 bg-navy text-center" data-id="element-140" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white" data-id="element-141" data-mp="3gfsoqi9xf4pm">
        © <span className="text-gold-light" data-id="element-142" data-mp="3ggk6ap6ov1ww">Wrestling Coach Ready</span> 2026 — All Rights
        Reserved.
      </p>
      <p className="text-xs text-white/70 mt-2" data-id="element-143" data-mp="32lrn9grlb3lk">
        Digital coaching material for wrestling coaches. Results depend on how the system is
        applied in training.
      </p>
    </footer>;
}